
import { ExternalLink } from "lucide-react";
import React from "react";
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();
  const links = [
    { name: t('home.weblink.1'), url: "https://gadchiroli.gov.in/" },
    { name: t('home.weblink.2'), url: "https://gadchiroli.gov.in/whos-who/" },
    { name: t('home.weblink.3'), url: "https://aaplesarkar.mahaonline.gov.in/en" },
  ];

  return (
    <footer
      className="mt-8 border-t text-amber-800"
      style={{
        background: "#fffbeb", // soft pastel yellow like Phone Support box
      }}
    >
      <div className="max-w-7xl mx-auto py-6 px-6 flex justify-center">
        {/* Quick Links (Centered) */}
        <div className="flex flex-wrap justify-center gap-4">
          {links.map((link, idx) => (
            <a
              key={idx}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 px-4 py-2 text-sm font-medium 
                         text-amber-800 bg-amber-50 border border-amber-200 rounded-lg shadow-sm
                         hover:bg-amber-100 hover:text-amber-900 hover:scale-105 hover:shadow-md
                         transition-all duration-300"
            >
              {link.name}
              <ExternalLink className="w-4 h-4" />
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
}
